import React from "react";
import "./style.css"; // Import the CSS file
import Icons from "../../../../../Config/Images";
import { useNavigate } from "react-router-dom";

const OnboardingHeader = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="header">
        {/* <h1 className='h1'>ZABALI</h1> */}
        <img
          style={{ cursor: "pointer" }}
          className="img-header-onboard"
          src={Icons.zabali_header_logo_icon}
          alt=""
          onClick={() => navigate("/home")}
        />
      </div>
    </>
  );
};

export default OnboardingHeader;
